//import Account from './../../Resources/script.js'
import commonfunctions from "../../Resources/commonfunctions";



export default {
    name: 'Account',
    mixins: [commonfunctions],
    data () {
        return {}
    },

    components: {
        
    },
     
    methods: {

        setPage(){
            // this.category = this.$store.getters['account/getCategory'];
            // if(Object.keys(this.category).length > 0){
            //     //get product details
            //     this.$store.dispatch('account/setCategoryProducts');
            //     let self = this;
            //     setTimeout(function(){
            //         self.products = self.$store.getters['account/getBusinessProducts'];
            //         self.category.category_products = self.$store.getters['account/getBusinessProducts'];
            //     }, 1000); //wait for 1sec
            // }
        },

        setProduct(data){
            this.$store.dispatch('account/setProduct',data);
            this.$router.push('/account/business/product');
        },

        prepAddProduct(){
            this.$router.push('/account/business/newproduct');
        },
    },

    created: function(){
        let self = this;
        localforage.getItem('xvue', function(err, value) { //quick with the callback version
            if(value != undefined) {
                self.category = value.account.store_sellpoint.store_category;
                //get from store first
                //self.category.category_products = value.account.store_sellpoint.store_category_products;
                // if(Object.keys(self.category.category_products).length == 0){
                //     self.loading = true;
                //     //ten get from server and re-store
                //     self.getBusinessCategoryProducts();
                // }else{
                //     self.loading = false;
                // }
                self.getBusinessCategoryProducts();
            }else{}
        });
        //this.setPage();
        this.setMenuTabInnerView('viewBusinessCategory','',''); //default view
    }
}


// WEBPACK FOOTER //
// ./src/pages/Account/Sellpoint/Category/script.js